import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "app-shell" }
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "side-nav" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "notification-anchor" }
const _hoisted_7 = { class: "notification-popover" }
const _hoisted_8 = { class: "notification-popover-head" }
const _hoisted_9 = { class: "notification-summary" }
const _hoisted_10 = { class: "notification-popover-actions" }
const _hoisted_11 = { class: "user-summary" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  class: "dropdown-trigger",
  type: "button",
  title: "用户菜单"
}
const _hoisted_15 = {
  key: 0,
  class: "review-dot"
}
const _hoisted_16 = { class: "space-option" }
const _hoisted_17 = {
  key: 0,
  class: "space-option-dot"
}
const _hoisted_18 = { class: "user-copy" }
const _hoisted_19 = { class: "welcome" }
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { class: "user-actions" }
const _hoisted_22 = { class: "main-panel" }

import { computed, onMounted, ref, watch } from "vue";
import { Message } from "@arco-design/web-vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import {
  getNotificationUnreadCount,
  readAllNotification,
} from "@/api/notification";
import { AdminReviewTodoVO, getReviewTodoCount } from "@/api/admin";
import { getMyReviewTodoCount } from "@/api/user";
import GlobalHeader from "@/components/GlobalHeader.vue";
import { RootState } from "@/store";
import { NotificationUnreadVO } from "@/types/notification";
import { UserReviewTodoVO } from "@/types/user";
import { getDefaultAvatarText } from "@/utils/avatar";


export default /*@__PURE__*/_defineComponent({
  __name: 'BasicLayout',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore<RootState>();
const logoutLoading = ref(false);
const unreadCount = ref(0);
const unreadSummary = ref<NotificationUnreadVO>({});
const adminReviewTodo = ref<AdminReviewTodoVO>({});
const userReviewTodo = ref<UserReviewTodoVO>({});

const menuItems = [
  { path: "/problems", title: "题库" },
  { path: "/posts", title: "讨论" },
  { path: "/submissions/my", title: "提交记录" },
  { path: "/score/stats", title: "排行榜" },
  { path: "/score/records", title: "积分记录" },
];

const adminMenuItems = [
  { path: "/admin", title: "后台首页" },
  { path: "/admin/users", title: "用户管理" },
  { path: "/admin/problems", title: "题目管理" },
  { path: "/admin/submissions", title: "提交查看" },
  { path: "/admin/posts", title: "帖子审核", countKey: "pendingPostCount" },
  { path: "/admin/post-categories", title: "帖子板块" },
  { path: "/admin/reports", title: "举报管理" },
  {
    path: "/admin/comments",
    title: "评论审核",
    countKey: "pendingProblemCommentCount",
  },
  {
    path: "/admin/post-comments",
    title: "帖子评论审核",
    countKey: "pendingPostCommentCount",
  },
];

const activeMenu = computed(() => String(route.meta.menuKey || route.path));
const loginUser = computed(() => store.state.user.loginUser);
const isAdmin = computed(() => loginUser.value?.userRole === "admin");
const userReviewTodoCount = computed(() =>
  Number(userReviewTodo.value.totalPendingCount || 0)
);
const hasUserReviewTodo = computed(() => userReviewTodoCount.value > 0);
const displayName = computed(
  () =>
    loginUser.value?.userName ||
    loginUser.value?.userAccount ||
    `User ${loginUser.value?.id || ""}`
);

const handleMenuClick = (key: string) => {
  router.push(key);
};

const getAdminMenuCount = (item: { countKey?: keyof AdminReviewTodoVO }) => {
  return item.countKey ? Number(adminReviewTodo.value[item.countKey] || 0) : 0;
};

const goUserProfile = () => {
  if (loginUser.value?.id) {
    router.push("/user/profile");
    return;
  }
  router.push("/user/login");
};

const goNotifications = () => {
  router.push("/notifications");
};

const handleUserMenuSelect = (
  value: string | number | Record<string, unknown>
) => {
  if (value === "profile") {
    router.push("/user/profile");
    return;
  }
  if (value === "space") {
    router.push("/user/space");
    return;
  }
  if (value === "logout") {
    void handleLogout();
  }
};

const handleLogout = async () => {
  logoutLoading.value = true;
  try {
    await store.dispatch("user/logout");
    Message.success("已退出登录");
    router.push("/user/login");
  } finally {
    logoutLoading.value = false;
  }
};

const fetchUnreadCount = async () => {
  if (!loginUser.value?.id) {
    unreadCount.value = 0;
    unreadSummary.value = {};
    return;
  }
  try {
    const data = await getNotificationUnreadCount();
    unreadSummary.value = data || {};
    unreadCount.value = Number(data.totalUnread || 0);
  } catch (error) {
    unreadCount.value = 0;
    unreadSummary.value = {};
  }
};

const fetchAdminReviewTodo = async () => {
  if (!isAdmin.value) {
    adminReviewTodo.value = {};
    return;
  }
  try {
    adminReviewTodo.value = (await getReviewTodoCount()) || {};
  } catch (error) {
    adminReviewTodo.value = {};
  }
};

const fetchUserReviewTodo = async () => {
  if (!loginUser.value?.id) {
    userReviewTodo.value = {};
    return;
  }
  try {
    userReviewTodo.value = (await getMyReviewTodoCount()) || {};
  } catch (error) {
    userReviewTodo.value = {};
  }
};

const handleNotificationPopup = (visible: boolean) => {
  if (visible) {
    fetchUnreadCount();
  }
};

const handleReadAllNotifications = async () => {
  await readAllNotification();
  Message.success("已全部标记为已读");
  await fetchUnreadCount();
};

watch(
  () => route.fullPath,
  () => {
    fetchUnreadCount();
    fetchAdminReviewTodo();
    fetchUserReviewTodo();
  }
);

watch(
  () => loginUser.value?.id,
  () => {
    fetchUnreadCount();
    fetchAdminReviewTodo();
    fetchUserReviewTodo();
  }
);

onMounted(() => {
  fetchUnreadCount();
  fetchAdminReviewTodo();
  fetchUserReviewTodo();
});

return (_ctx: any,_cache: any) => {
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _createVNode(GlobalHeader),
      _createElementVNode("nav", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
          return _createElementVNode("button", {
            key: item.path,
            class: _normalizeClass(["nav-item", { active: activeMenu.value === item.path }]),
            onClick: ($event: any) => (handleMenuClick(item.path))
          }, [
            _createElementVNode("span", null, _toDisplayString(item.title), 1)
          ], 10, _hoisted_4)
        }), 64)),
        (isAdmin.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "nav-divider" }, "Admin", -1)),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(adminMenuItems, (item) => {
                return _createElementVNode("button", {
                  key: item.path,
                  class: _normalizeClass(["nav-item admin", { active: activeMenu.value === item.path }]),
                  onClick: ($event: any) => (handleMenuClick(item.path))
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.title), 1),
                  (getAdminMenuCount(item) > 0)
                    ? (_openBlock(), _createBlock(_component_a_badge, {
                        key: 0,
                        count: getAdminMenuCount(item),
                        "max-count": 99,
                        class: "nav-count"
                      }, null, 8, ["count"]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_5)
              }), 64))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["user-card", { authenticated: loginUser.value?.id }])
      }, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "user-card-bg" }, null, -1)),
        (loginUser.value?.id)
          ? (_openBlock(), _createBlock(_component_a_popover, {
              key: 0,
              trigger: "click",
              position: "right",
              onPopupVisibleChange: handleNotificationPopup
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("strong", null, "消息通知", -1)),
                    _createElementVNode("span", null, _toDisplayString(unreadCount.value) + " 条未读", 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", null, "回复", -1)),
                      _createElementVNode("strong", null, _toDisplayString(unreadSummary.value.replyUnread || 0), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", null, "点赞", -1)),
                      _createElementVNode("strong", null, _toDisplayString(unreadSummary.value.thumbUnread || 0), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("span", null, "收藏", -1)),
                      _createElementVNode("strong", null, _toDisplayString(unreadSummary.value.favourUnread || 0), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", null, "系统", -1)),
                      _createElementVNode("strong", null, _toDisplayString(unreadSummary.value.systemUnread || 0), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_a_button, {
                      size: "mini",
                      type: "primary",
                      onClick: goNotifications
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode(" 查看消息 ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      size: "mini",
                      disabled: unreadCount.value === 0,
                      onClick: handleReadAllNotifications
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode(" 全部已读 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_badge, {
                    count: unreadCount.value,
                    "max-count": 99
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("button", {
                        class: "notification-trigger",
                        type: "button",
                        title: "消息通知"
                      }, [
                        _createElementVNode("svg", {
                          viewBox: "0 0 24 24",
                          "aria-hidden": "true"
                        }, [
                          _createElementVNode("path", { d: "M18 10.5c0-3.3-2.1-5.7-5-6.2V3a1 1 0 0 0-2 0v1.3c-2.9.5-5 2.9-5 6.2v3.2l-1.3 2.1A1.1 1.1 0 0 0 5.6 17h12.8a1.1 1.1 0 0 0 .9-1.7L18 13.7v-3.2ZM9.6 18.2a2.5 2.5 0 0 0 4.8 0" })
                        ])
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["count"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "avatar-button",
            type: "button",
            onClick: goUserProfile
          }, [
            _createVNode(_component_a_avatar, {
              size: 42,
              class: "avatar"
            }, {
              default: _withCtx(() => [
                (loginUser.value?.userAvatar)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: loginUser.value.userAvatar,
                      alt: ""
                    }, null, 8, _hoisted_12))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(getDefaultAvatarText)(displayName.value)), 1))
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_a_dropdown, {
            trigger: "click",
            onSelect: handleUserMenuSelect
          }, {
            content: _withCtx(() => [
              _createVNode(_component_a_doption, { value: "profile" }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("个人中心", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_a_doption, { value: "space" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_16, [
                    _cache[12] || (_cache[12] = _createTextVNode(" 我的空间 ", -1)),
                    (hasUserReviewTodo.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              (loginUser.value?.id)
                ? (_openBlock(), _createBlock(_component_a_divider, {
                    key: 0,
                    margin: 4
                  }))
                : _createCommentVNode("", true),
              (loginUser.value?.id)
                ? (_openBlock(), _createBlock(_component_a_doption, {
                    key: 1,
                    value: "logout"
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode(" 退出登录 ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createElementVNode("button", _hoisted_14, [
                (hasUserReviewTodo.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                  : _createCommentVNode("", true),
                _cache[10] || (_cache[10] = _createElementVNode("svg", {
                  viewBox: "0 0 24 24",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("path", { d: "m7 10 5 5 5-5" })
                ], -1))
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(loginUser.value?.id ? "Welcome back" : "Welcome"), 1),
          _createElementVNode("div", _hoisted_20, _toDisplayString(displayName.value), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          (loginUser.value?.id)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                class: "logout-button",
                size: "small",
                status: "danger",
                type: "text",
                loading: logoutLoading.value,
                onClick: handleLogout
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode(" 退出登录 ", -1)
                ]))]),
                _: 1
              }, 8, ["loading"]))
            : (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                size: "mini",
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/user/login')))
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode(" 登录 ", -1)
                ]))]),
                _: 1
              }))
        ])
      ], 2)
    ]),
    _createElementVNode("main", _hoisted_22, [
      _createVNode(_component_router_view)
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("footer", { class: "site-footer" }, [
      _createElementVNode("a", {
        href: "https://beian.miit.gov.cn/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, " 陕ICP备2026023999号 ")
    ], -1))
  ]))
}
}

})